import { Action } from 'redux'
import { ICopyFormValues } from '../../../containers/BookingCalendar/CopyReservationModal/CopyReservationForm'
import { EventActions } from '../../../reducers/bookingCalendar/actionNames'
import { IEvent } from '../../../models/Event'
import { createFormActions } from '../../form'

const requestCopyReservation = createFormActions<ICopyFormValues>(
  EventActions.RequestCopyReservation,
)

const reservationWasCopied = (events: IEvent[]): IReservationWasCopied => ({
  events,
  type: EventActions.ReservationWasCopied,
})

export interface IReservationWasCopied
  extends Action<EventActions.ReservationWasCopied> {
  events: IEvent[]
}

export { reservationWasCopied }
export default requestCopyReservation
